import { apiGet, apiPost, apiPut, apiDelete, ApiError } from '@/app/api/core/http';
import { createImage, updateImage, uploadImages } from '@/app/api/core/images';
import { CAT_BRANDS } from 'App/utils/Collections';
import { BRANDS_PATHS } from './paths';

export const brandsApiAdapter = {
  getBrands: (params, cat, headers) => {
    const { clearParams, ...rest } = params;
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(BRANDS_PATHS.brands + BRANDS_PATHS.suffix, preparedParams);
  },
  getBrandsDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${BRANDS_PATHS.brands}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${BRANDS_PATHS.brands}/${id}`, { is_protected: true });
    }
  },
  createBrand: (data) => {
    return apiPost(BRANDS_PATHS.brands, { data, is_protected: true }).then(async (res) => {
      if (res.status === 201) {
        await uploadImages(CAT_BRANDS, data.images, {
          brand_id: res.data.id,
        }).catch();
      } else {
        throw new ApiError('Can not save brand', res);
      }
      return res;
    });
  },
  updateBrand: (id, data) => apiPut(`${BRANDS_PATHS.brands}/${id}`, { data, is_protected: true }),
  deleteBrand: (id) => apiDelete(`${BRANDS_PATHS.brands}/${id}`, { is_protected: true }),
  getBrandHistory: (id) => apiGet(`${BRANDS_PATHS.brands}/${id}/history`),
  getBrandSnapshotById: (id, snapshot_id) => apiGet(`${BRANDS_PATHS.brands}/${id}/history/snapshots/${snapshot_id}`),
  brands: {
    images: {
      create: (img, id, is_default = false, session_interval = 0) =>
        createImage(CAT_BRANDS, img, { brand_id: id, is_default, session_interval }),
      update: (id, data) => updateImage(CAT_BRANDS, id, data),
      remove: (id) => apiDelete(`${BRANDS_PATHS.images}/${id}`),
      getList: (id, params = {}) =>
        apiGet(BRANDS_PATHS.images, {
          params: {
            ...params,
            'brand.id': id,
          },
        }),
    },
  },
};

export const brandsFilterAdapter = {
  getProductBrands: (params) => apiGet(BRANDS_PATHS.brands, params),
};
